import { Controller } from 'stimulus';
import { t } from '../javascript/lib/i18n';

export default class extends Controller {
  validateFile(event) {
    const acceptedTypes = [
      'image/jpeg',
      'image/png',
      'image/jpg',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    if (!acceptedTypes.includes(event.file.type)) {
      event.preventDefault();
      alert(t('js.trix_editor.unsupported_type'));
    }

    const maxFileSize = 3 * 1024 * 1024;
    // Limit attachment size to 3MB
    if (event.file.size > maxFileSize) {
      event.preventDefault();
      alert(t('js.trix_editor.too_large'));
    }
  }
}
